<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="d-flex justify-content-center">
        <div class="alert alert-warning justify-content-center align-items-center" style="width: 100%;">
          <span class="font-weight-bold text-danger">توجه:</span>
          <span class="mr-1">تمامی مبالغ به <span class="font-weight-bold">ریال</span> می‌باشد.</span>
        </div>
      </div>
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش فروشگاه حضوری</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="ml-3" :url="excelUrl" />
        <button @click="print" class="btn btn-primary">
          <span style="transform: translateY(3px)" class="feather-printer"></span>
        </button>
      </div>
      <div class="row px-4 not-in-print">
        <DatePickerRange class="col-md-6" v-model="filterDate" />
        <CustomerSearch :showLabel="false" class="col-md-6" :disabled="disabled" v-model="filterSelectedCustomer" />
        <b-form-group class="col-4">
          <multiselect placeholder="انتخاب انبار" v-model="selectedStores" open-direction="bottom" :options="stores"
            label="label" track-by="id" :multiple="true" :searchable="true" :close-on-select="false"
            :show-labels="false" :disabled="disabled">
            <template slot="noOptions">موردی یافت نشد</template>
            <template slot="noResult">موردی یافت نشد</template>
          </multiselect>

        </b-form-group>
        <div class="col-4" v-if="admin_role !== 'cashier'">
          <select v-model="admin_id" class="form-control">
            <option v-for="admin in admins" :value="admin.id">{{ admin.name }}</option>
            <option :value="null">انتخاب صندوق دار</option>
          </select>
        </div>
        <b-form-group class="col-md-3">
          <b-form-input placeholder="مبلغ(ریال)" :value="filterAmount | priceinput" @input="
            (value) => {
              filterAmount =
                value !== '' ? +value.replace(/\D/g, '') : '';
            }
          " />
        </b-form-group>
      </div>
      <b-button class="col-md-2 mr-3" variant="primary" @click="doFilter" :disabled="disabled">فیلترسازی</b-button>
      <div id="print" class="p-4">
        <div class="print-only">
          <h4>فروشگاه الینور</h4>
        </div>
        <br>
        <div class="d-flex mb-3 mr-2-print">
          <span class="ml-1 font-bold">گزارش فروشگاه حضوری</span>
          <div v-if="filterDate.startDate">
            <span>از</span>
            <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.startDate | persianDate }} </span>
          </div>
          <div class="mr-3" v-if="filterDate.endDate">
            <span>تا</span>
            <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.endDate | persianDate }} </span>
          </div>
        </div>
        <b-table v-if="reports" bordered striped :fields="fields" :items="reports" responsive>
          <template v-slot:cell(id)="data">
            <a :href="`/admin/shop/orders/${data.item.order_id}`" class="btn btn-primary" target="_blank"
              rel="noopener noreferrer">{{ data.item.order_id }}</a>
          </template>
          <template v-slot:cell(refund_quantity)="data">
            {{ data.item.refund_quantity }}
          </template>
          <template v-slot:cell(total_sale)="data">
            {{ data.item.total_sale < 0 ? "-" : "" }}{{ data.item.total_sale * 10 | price }} </template>
              <template v-slot:cell(product_title)="data">
                <a target="_blank" :href="'/admin/products/edit/' + data.item.product_id">{{ data.item.product_title
                }}</a>
              </template>
              <template v-slot:cell(customer)="data">
                {{ (data.item.customer_first_name + " " + data.item.customer_last_name) | price }}
              </template>
              <template v-slot:cell(mobile)="data">
                {{ (data.item.customer_first_name + " " + data.item.customer_last_name) | price }}
              </template>
              <template v-slot:cell(pos)="data">
                {{ data.item.pos * 10 | price }}
              </template>
              <template v-slot:cell(card_by_card)="data">
                {{ data.item.card_by_card * 10 | price }}
              </template>
              <template v-slot:cell(cash)="data">
                {{ data.item.cash * 10 | price }}
              </template>
              <template v-slot:cell(buy_price)="data">
                {{ data.item.buy_price * 10 | price }}
              </template>
              <template v-slot:cell(discount_amount)="data">
                {{ data.item.discount_amount * 10 | price }}
              </template>
              <template v-slot:cell(wallet)="data">
                {{ data.item.wallet * 10 | price }}
              </template>
              <template v-slot:cell(refund)="data">
                {{ data.item.refund * 10 | price }}
              </template>
              <template v-slot:cell(changeAmount)="data">
                {{ data.item.changeAmount * 10 | price }}
              </template>
              <template #bottom-row="data">
                <b-td>*</b-td>
                <b-td>*</b-td>
                <b-td>جمع کل:</b-td>
                <b-td>{{ sum_items | price }}</b-td>
                <b-td>{{ totals.discount_amount * 10 | price }}</b-td>
                <b-td>{{ totals.pos * 10 | price }}</b-td>
                <b-td>{{ totals.wallet_amount * 10 | price }}</b-td>
                <b-td>{{ totals.card_by_card * 10 | price }}</b-td>
                <b-td>{{ totals.cash * 10 | price }}</b-td>
                <b-td>{{ totals.refund_quantity | price }}</b-td>
                <b-td>{{ totals.refund_amount * 10 | price }}</b-td>
                <b-td>{{ totals.changes_count | price }}</b-td>
                <b-td>{{ totals.changes_amount * 10 | price }}</b-td>
                <b-td>{{ totals.amount * 10 | price }}</b-td>
              </template>
        </b-table>
        <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd, BFormCheckbox } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";

export default {
  name: "ProductsReport",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    ProductSearch,
    BButton,
    BTd,
    DatePickerRange,
    ExcelDownload,
    CustomerSearch,
    BFormCheckbox,
  },
  configProvider,
  data() {
    return {
      disabled: false,
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "customer_name",
          label: "مشتری",
        },
        {
          key: "buy_time",
          label: "زمان خرید",
        },
        {
          key: "sum_items",
          label: "تعداد آیتم ها ",
        },
        {
          key: "discount_amount",
          label: "مبلغ تخفیف",
        },
        {
          key: "pos",
          label: "از پوز",
        },
        {
          key: "wallet",
          label: "از کیف پول",
        },
        {
          key: "card_by_card",
          label: "از کارت",
        },
        {
          key: "cash",
          label: "از نقدی",
        },
        {
          key: "refund_quantity",
          label: "تعداد مرجوعی",
        },
        {
          key: "refund",
          label: "مبلغ مرجوعی",
        },
        {
          key: "changeQuantity",
          label: "تعداد تعویض",
        },
        {
          key: "changeAmount",
          label: "مبلغ تعویض",
        },
        {
          key: "buy_price",
          label: "مبلغ خرید",
        },
        {
          key: "buy_price",
          label: "مبلغ خرید",
        },

      ],
      page: 1,
      reports: null,
      sortBy: null,
      admin_role: null,
      sortDesc: null,
      totals: null,
      filterAmount: null,
      selectedStores: null,
      stores: [],
      admins: [],
      admin_id: null,
      filterDate: {
        endDate: "",
        startDate: "",
      },
      filterSelectedCustomer: "",
      Variety_id: "",
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  computed: {
    sum_items() {
      if (this.reports.length) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sum_items),
          0
        );
      } else {
        return 0;
      }
    },
    sum_discount_amount() {
      if (this.reports.length) {
        return this.reports.reduce(
          (total, item) => total + Number(item.discount_amount),
          0
        );
      } else {
        return 0;
      }
    },
    sum_buy_price() {
      if (this.reports.length) {
        return this.reports.reduce(
          (total, item) => total + Number(item.buy_price),
          0
        );
      } else {
        return 0;
      }
    },
    excelUrl() {
      const params = new URLSearchParams();

      if (this.admin_id) {
        params.append('admin_id', this.admin_id);
      }

      if (this.filterDate?.startDate) {
        params.append('start_date', this.filterDate.startDate);
      }

      if (this.filterDate?.endDate) {
        params.append('end_date', this.filterDate.endDate);
      }

      if (this.filterAmount) {
        params.append('amount', this.filterAmount / 10);
      }

      if (this.filterSelectedCustomer?.id) {
        params.append('customer_id', this.filterSelectedCustomer.id);
      }

      this.selectedStores?.forEach((store) => {
        if (store?.id) {
          params.append('store_ids[]', store.id);
        }
      });

      return `admin/reports/customers-new?${params.toString()}`;
    },
  },
  created() {
    this.loadStores();
    this.loadData();
  },
  methods: {
    print() {
      window.print();
    },
    resetFilter() {
      this.Product_id = "";
      this.Variety_id = "";
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    async loadStores() {
      try {
        const response = await this.$axios.get("admin/stores");
        this.stores = response.data.data.stores;
        this.disabled = false;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    async loadData() {
      this.disabledRest = false;
      try {
        const today = new Date();
        const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);

        function formatDate(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');

          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
        if (!this.filterDate.startDate || !this.filterDate.endDate) {
          this.filterDate.startDate = formatDate(startOfToday);
          this.filterDate.endDate = formatDate(today);
        }
        this.disabled = true;
        const home = await this.$axios.get("admin/home");
        if (home.data.data.admin.role.name == 'cashier') {
          this.admin_id = home.data.data.admin.id;
          this.admin_role = home.data.data.admin.role.name;
        }
        const amount = this.filterAmount ? this.filterAmount / 10 : '';

        const response = await this.$axios.get("admin/reports/customers-new", {
          params: {
            admin_id: this.admin_id,
            start_date: this.filterDate.startDate,
            end_date: this.filterDate.endDate,
            store_ids: this.selectedStores && this.selectedStores.length > 0
              ? this.selectedStores.map(store => store.id)
              : [],
            amount: amount,
            customer_id: this.filterSelectedCustomer
              ? this.filterSelectedCustomer.id
              : "",
          },
        });
        this.admins = response.data.data.admins;
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
        console.log(this.reports, 'this.reports');

      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-varieties-modal");
      this.showVarietiesProductId = productId;
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}

@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: flex;
    justify-content: center;
  }

  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
    font-size: 0.9rem;
  }

  #print {
    padding: 0 !important;
  }

  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>